import { gql } from '@apollo/client';
import { useDisclosure } from '@chakra-ui/react';

import { useCurrent } from '@/hooks/useCurrent';

import { useShowPostResponses_PostFragment } from './graphql-types/useShowPostResponses_PostFragment';

export const useShowPostResponses = (
  post: useShowPostResponses_PostFragment | null
): {
  showPostResponses?: boolean;
  loading: boolean;
  behaviorOverride?: () => void;
  paywallDisclosure: {
    onOpen: () => void;
    onClose: () => void;
    isOpen: boolean;
  };
  loginDisclosure: {
    onOpen: () => void;
    onClose: () => void;
    isOpen: boolean;
  };
} => {
  const current = useCurrent();

  const paywallDisclosure = useDisclosure();
  const loginDisclosure = useDisclosure();

  if (!post) {
    return {
      paywallDisclosure,
      loginDisclosure,
      loading: false,
    };
  }

  const behaviorOverride = post.currentUserCanRespondToPost
    ? undefined
    : !current.user?._id
    ? loginDisclosure.onOpen
    : !!post.currentUserCanAttemptToRespondToPostWithOrganizationSponsorshipPaywall
    ? paywallDisclosure.onOpen
    : undefined;

  return {
    showPostResponses:
      !current.user?._id ||
      !!post.currentUserCanRespondToPost ||
      !!post.currentUserCanAttemptToRespondToPostWithOrganizationSponsorshipPaywall,
    loading: current.loading,
    paywallDisclosure,
    loginDisclosure,
    behaviorOverride,
  };
};
useShowPostResponses.postFragment = gql`
  fragment useShowPostResponses_PostFragment on PostV2 {
    _id
    currentUserCanRespondToPost
    currentUserCanAttemptToRespondToPostWithOrganizationSponsorshipPaywall
  }
`;
